var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{ref:"logo",staticClass:"o-logo",attrs:{"title":"ÉMCV","aria-label":"Retour à l’accueil","to":"/"}},[_c('icon',{attrs:{"icon":_vm.logo,"title":"ÉMCV"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }